<template>
  <!-- Growth is the parent's call: beside the chart this takes its natural height, but on its own it
       has to fill the row. Both are impossible to express from in here. -->
  <v-card class="py-6" rounded="lg" elevation="0">
    <div class="px-6 subtitle2 mb-4">{{ $t("network.overview.regions.title") }}</div>

    <div v-if="loading" class="px-6">
      <v-skeleton-loader type="list-item-two-line" />
    </div>

    <div v-else class="px-6">
      <div v-for="row in rows" :key="row.region" class="region-row mb-4">
        <div class="body2 mb-1">{{ $t(`network.overview.region.${row.region}`) }}</div>
        <div class="d-flex align-center">
          <v-progress-linear
            :model-value="row.count"
            :max="maxCount"
            color="primary"
            height="4"
            rounded
          />
          <div class="ml-4 subtitle2 region-value">{{ row.count }}</div>
        </div>
      </div>

      <div v-if="!rows.length" class="body2 text-indigo-medium">
        {{ $t("network.overview.regions.empty") }}
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import type { NetworkRegionCount } from "@/_store/network/network-analytics.module";

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<NetworkRegionCount[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const rows = computed(() => props.items ?? []);

    /**
     * Bars are scaled against the largest region rather than the total, so the smallest region stays
     * visible instead of collapsing to a sliver. Reduced rather than spread into Math.max, whose
     * argument list is bounded by the call stack.
     */
    const maxCount = computed(() => rows.value.reduce((max, row) => Math.max(max, row.count), 1));

    return { rows, maxCount };
  },
});
</script>

<style scoped lang="scss">
.region-value {
  min-width: 40px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
</style>
